import React, { useState } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';

import AdminTableRow from './AdminTableRow';
import styles from './AdminTable.module.css';

const AdminTable = ({
  model,
  rows,
  isLoading,
  idFieldName,
  imagesFieldName,
  onClickEdit,
  hasActions,
  emptyIconClassName,
  emptyTitle,
  emptyDescription,
}) => {
  const [imagesOpen, setImagesOpen] = useState(null);

  const renderTableBody = () => {
    if (isLoading) {
      // renders the loading screen
      return (
        <tr>
          <td className={styles.noData}>
            <p>Loading Data...</p>
          </td>
        </tr>
      );
    }

    if (isEmpty(rows)) {
      return (
        <tr>
          <td className={styles.noData}>
            <i className={emptyIconClassName} />
            <p className={styles.title}>{emptyTitle}</p>
            <p className={styles.description}>{emptyDescription}</p>
          </td>
        </tr>
      );
    }

    return map(rows, (row, index) => {
      // idFieldName is a string (eg. "productId") to assign an id to the element
      const rowId = row[idFieldName];
      const key = `${index}-${rowId}`;
      return (
        <AdminTableRow
          key={key}
          model={model}
          row={row}
          rowId={rowId}
          imagesOpen={imagesOpen}
          imagesFieldName={imagesFieldName}
          setImagesOpen={setImagesOpen}
          onClickEdit={onClickEdit}
          hasActions={hasActions}
        />
      );
    });
  };

  return (
    <div className={styles.container}>
      <table className={styles.adminTable}>
        <thead>
          <tr>
            {map(model, (col) => (
              <th
                key={col.key}
                style={{
                  minWidth: col.minWidth,
                }}
              >
                {col.label}
              </th>
            ))}
            {hasActions && (
              <th className={styles.actionsHeader}>
                <span>Actions</span>
              </th>
            )}
          </tr>
        </thead>
        <tbody>{renderTableBody()}</tbody>
      </table>
    </div>
  );
};

AdminTable.propTypes = {
  model: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  isLoading: PropTypes.bool.isRequired,
  idFieldName: PropTypes.string.isRequired,
  imagesFieldName: PropTypes.string,
  onClickEdit: PropTypes.func,
  hasActions: PropTypes.bool,
  emptyIconClassName: PropTypes.string,
  emptyTitle: PropTypes.string,
  emptyDescription: PropTypes.string,
};

AdminTable.defaultProps = {
  imagesFieldName: null,
  onClickEdit: () => {},
  hasActions: false,
  emptyIconClassName: null,
  emptyTitle: null,
  emptyDescription: null,
};

export default AdminTable;
